import { useEffect } from 'react'
import seqStore from '../../store/seqStore'

export default function Pulses() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)
    const pulses = seqStore((state) => state.settings.pulses)
    const setPulses = seqStore((state) => state.setPulses)
    const length = seqStore((state) => state.settings.length)

    // update pulses when length is smaller that current pulses and store it 
    useEffect(() => {
        if (pulses[currentTrack] > length[currentTrack]) {
            setPulses(currentTrack, length[currentTrack])
        }
    }, [length, currentTrack, pulses, setPulses])

    // PULSES CONTROLS
    const handlePulses = (e) => {
        let value = Number(e.target.value)
        if (value > length[currentTrack]) {
            value = length[currentTrack]
        }
        setPulses(currentTrack, value);
    }

    const resetPulses = () => {
        setPulses(currentTrack, length)
    }
    
    return (
        <div id='pulsesInput'>
            <label htmlFor="root note">Pulses <span>{pulses[currentTrack]}</span></label>
            <input id='enabledInput' type="range" min={1} max={length[currentTrack]} step='1' value={pulses[currentTrack]} onChange={e => handlePulses(e)} onDoubleClick={resetPulses}/>
        </div>
    )
}
